<template>
  <section class="section">
    <div class="container">
      <div v-if="hasSimulations" class="columns is-multiline">
        <SimulationCard
          v-for="(simulation, index) in simulations"
          :key="index"
          :simulation="simulation"
          @delete-simulation="deleteSimulation"
        ></SimulationCard>
      </div>
      <p v-else class="has-text-centered is-size-5">Add a simulation to start!</p>
      <div class="container has-text-centered">
        <button class="button" @click="createSimulation">Add simulation</button>
      </div>
    </div>
  </section>
</template>

<script>
import SimulationCard from "./SimulationCard";
import Simulation from "../../models/simulation";
export default {
  name: "SimulationsList",
  components: { SimulationCard },
  computed: {
    simulations() {
      return this.$store.state.simulations;
    },
    hasSimulations() {
      return this.simulations.length > 0;
    }
  },
  methods: {
    deleteSimulation(simulation) {
      this.$store.dispatch("deleteSimulation", simulation);
    },
    createSimulation: function() {
      const simulation_number = this.simulations.length + 1;
      const simulation = new Simulation(
        "Simulation " + simulation_number,
        [{ attack: { action: 3, power: 0 }, damage: { action: 3, power: 0 } }],
        { action: 3, power: 0 },
        3,
        {}
      );
      this.$store.dispatch("editSimulation", simulation);
    }
  }
};
</script>

<style scoped></style>
